export default {
  data() {
    return {
      data: {
        title: "MASTER_SLIDE",
        bkgd: "FFFFFF",
        objects: [
          {
            text: {
              text: "Trusted Accountant",
              options: {
                x: 0.6,
                y: 5.23,
                w: 6.5,
                h: 0.33,
                fontFace: "Arial",
                fontSize: 6.8,
                charSpacing: 10,
                color: "9D968D",
                valign: "top",
              },
            },
          },
        ],
        slideNumber: {
          x: 0.42,
          y: 5.23,
          fontFace: "Arial",
          fontSize: 6.8,
          color: "9D968D",
        },
      },
      data2: {
        title: "MASTER_SLIDE2",
        bkgd: "FFFFFF",
        objects: [
          {
            text: {
              text: "- Trusted Accountant",
              options: {
                x: 0.6,
                y: 5.23,
                w: 6.5,
                h: 0.33,
                fontFace: "Arial",
                fontSize: 6.8,
                charSpacing: 10,
                color: "9D968D",
                valign: "top",
              },
            },
          },
        ],
        slideNumber: {
          x: 0.42,
          y: 5.23,
          fontFace: "Arial",
          fontSize: 6.8,
          color: "9D968D",
        },
      },
      data3: {
        title: "FIRST_SLIDE",
        bkgd: "FFFFFF",
        objects: [{ image: { x: 7.35, y: 0.35, w: 2.25, h: 1, path: "../img/logo.png" } }],
      },
    };
  },
};
